module.exports = __webpack_public_path__ + "img/still (7).05a12da3.jpg";